<template>
  <div class="sort filter-form">
    <b-form-radio v-for="option in options" :key="option.id"
                  name="sort" :value="option" v-model="selected"
    >
      {{ $t(transKey + option) }}
    </b-form-radio>

    <p class="text-right">
      <b-button class="btn-as-link" @click="selected = null">
        {{ $t('_reset') }}
      </b-button>
    </p>
  </div>
</template>

<script>
export default {
  props: {
    transKey: {
      type: String,
      default: ''
    },
    options: Array
  },

  data () {
    return {
      selected: null
    }
  },

  methods: {
    emitChanges () {
      this.$emit('change', this.selected)
    }
  },

  watch: {
    selected (val) {
      this.emitChanges()
    }
  }
}
</script>
